@if (user()) {
	<div>
		<a id=" contact" routerLink="{{'image.metanav.contact.email' | msgKey}}">
			{{"image.metanav.contact.alt" | msgKey}}
		</a>
		<ng-content></ng-content>
	</div>
}